import { Component, OnInit } from '@angular/core';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import * as pluginDataLabels from 'chart.js';
import { Label } from 'ng2-charts';
import * as moment from 'moment'
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { environment } from '../../../../../environments/environment';
import { AuthenticationService } from 'src/app/services/shared/auth.service';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import { AdminService } from 'src/app/services/admin/admin.service';
import { ReportService } from 'src/app/services/report/report.service';
import { DeliveryPlatformService } from 'src/app/services/delivery/delivery-platform.service';
import { UserService } from 'src/app/services/user/user.service';


declare var $: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  myDateValue: Date;
  selectedStartDate: string;
  public selectorActive: number = 1;
  public tabActive: number = 1;

  public acceptingOrders: boolean = false;
  public isDataLoaded: boolean = false

  public currency = `${environment.currency}`;
  public currency_logo = `${environment.currency_logo}`;
  public collectionName = `${environment.x_tenant_code}`
  //tile config
  dashboardTileTypeTotal: string;
  dashboardTileTypeAccepted: string;
  dashboardTileTypeCompleted: string;
  dashboardTileTypeReady: string;
  dashboardTileTypeDeclined: string;
  dashboardTileTypeCanceled: string;
  totalCount: number
  acceptedCount: number
  completedCount: number
  readyCount: number
  declinedCount: number
  canceledCount: number
  bestSellingPlatform: string
  bestSellingProducts: any
  totalrevenue: number;
  totalrevenue2: number = 30000;
  startDate: any;
  endDate: any;
  selectedFranchise: any;
  loggedUserRole: any;

  franchises: any;
  shops: any;
  activeBrands: any;
  selectedOutletCode: any;
  selectedActiveBrand: any;

  selectedFilterFranchise: any = null;
  selectedFilterShop: any = null;
  outletCodes: any = [];
  isFilterClicked = false;

  integrationsList = [];

  totalReservations: any;
  totalReservationsRevenue: any;
  bestZone: any;
  totalNetRevenue: any


  /* Chart Configs */
  public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'bottom',
    },
    plugins: {
      datalabels: {
        formatter: (value, ctx) => {
          const label = ctx.chart.data.labels[ctx.dataIndex];
          return label;
        },
      },
    }
  };


  public barChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'bottom',
    },
    // We use these empty structures as placeholders for dynamic theming.
    scales: {
      xAxes: [{}],
      yAxes: [{
        ticks: {
          beginAtZero: true
        }
      }]
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      }
    }
  };
  public barChartLabels: Label[] = [];
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [pluginDataLabels];

  public barChartData: ChartDataSets[] = [
    { data: [], label: 'Uber Eats', backgroundColor: 'black' },
    { data: [], label: 'Just Eat', backgroundColor: '#e22006' },

  ];

  public pieChartLabels: Label[] = [['Item', 'Revenue'], ['In', 'Store', 'Sales'], 'Mail Sales'];
  public pieChartData: number[] = [300, 500, 100];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [pluginDataLabels];
  public pieChartColors = [
    {
      backgroundColor: ['#ff9ff3', '#feca57', '#ff6b6b', '#48dbfb', '#1dd1a1', '#f368e0', '#ff9f43', '#ee5253', '#0abde3', '#10ac84', '#00d2d3', '#54a0ff', '#5f27cd', '#576574', '#01a3a4', '#2e86de', '#341f97', '#222f3e', '#f1c40f', '#e67e22', '#e74c3c', '#f39c12', '#d35400', '#c0392b'],
    },
  ];

  public revenueBarChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'bottom',
    },
    // We use these empty structures as placeholders for dynamic theming.
    scales: {
      xAxes: [{}],
      yAxes: [{
        ticks: {
          beginAtZero: true
        }
      }]
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      }
    }
  };
  public revenueBarChartLabels: Label[] = [];
  public revenueBarChartType: ChartType = 'bar';
  public revenueBarChartLegend = true;
  public revenueBarChartPlugins = [pluginDataLabels];

  public revenueBarChartData: ChartDataSets[] = [
  ];

  colorTheme = 'theme-dark-blue';

  bsConfig: Partial<BsDatepickerConfig>;

  constructor(
    private reportService: ReportService,
    private router: Router,
    private userService: UserService,
    private authService: AuthenticationService,
    private firestore: AngularFirestore,
    private adminService: AdminService,
    private deliveryService: DeliveryPlatformService,
  ) {
  }


  ngOnInit() {
    this.getCurrentUser();
    this.bsConfig = Object.assign({}, { containerClass: this.colorTheme });

    this.myDateValue = new Date();
    this.dashboardTileTypeTotal = 'total'
    this.dashboardTileTypeAccepted = 'accepted';
    this.dashboardTileTypeCompleted = 'completed';
    this.dashboardTileTypeReady = 'ready';
    this.dashboardTileTypeDeclined = 'declined';
    this.dashboardTileTypeCanceled = 'canceled';
    this.acceptingOrders = this.getRestaurantStatus();

    this.getActiveBrands();
    this.getAllFranchises();
    this.getTenants();

    var today = moment().format('YYYY-MM-DD');
    this.startDate = today;
    this.endDate = today;

    if (localStorage.getItem('firebaseListner_Dashboard') == 'Active') {

      if (this.selectedFilterFranchise && this.selectedFilterShop) {
        this.outletCodes.push(this.selectedOutletCode);
        this.getDashbaordData(this.startDate, this.endDate);
      } else {
        this.outletCodes = this.authService.getLoggedUser().user_outlets;
        this.getDashbaordData(this.startDate, this.endDate);
      }

    } else {
      this.listenFirebase();
    }

    $('.selectpicker').selectpicker('refresh');

    this.getIntegrations();

  }

  public listenFirebase() {

    if (this.authService.getLoggedUser().user_roles.role_id == 4) {

      let firebase_code = this.collectionName + '_' + this.authService.getLoggedUser().outlet_code;

      this.firestore.collection(firebase_code).snapshotChanges().subscribe(res => {

        if (this.selectedFilterFranchise && this.selectedFilterShop) {
          this.outletCodes.push(this.selectedOutletCode);
          this.getDashbaordData(this.startDate, this.endDate);
        } else {
          this.outletCodes = this.authService.getLoggedUser().user_outlets;
          this.getDashbaordData(this.startDate, this.endDate);
        }
        localStorage.setItem('firebaseListner_Dashboard', 'Active');

      });
    } else {

    }

  }

  filterForm: FormGroup = new FormGroup({
    franchise: new FormControl(''),
    shop: new FormControl(''),
    brand: new FormControl(''),
  })

  dateForm: FormGroup = new FormGroup({
    date: new FormControl(''),
  })

  // events
  public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }): void {
  }

  public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
  }


  public todayPressed() {
    var now = moment();
    var last7dasy = moment().subtract(7, 'days');
  }

  selectorPressed(selectorId) {
    this.dateForm.reset();
    var today = moment().format('YYYY-MM-DD');
    this.selectorActive = selectorId;
    switch (selectorId) {
      case 1: {
        this.isDataLoaded = false;
        this.getDashbaordData(today, today)
        this.startDate = today;
        this.endDate = today;
      }
        break;
      case 2: {
        this.isDataLoaded = false;
        var yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
        this.getDashbaordData(yesterday, yesterday)
        this.startDate = yesterday;
        this.endDate = yesterday;
      }
        break;
      case 3: {
        this.isDataLoaded = false;
        var last7dasy = moment().subtract(7, 'days').format('YYYY-MM-DD');
        let lastend7days = moment().subtract(1, 'days').format('YYYY-MM-DD');
        this.getDashbaordData(last7dasy, lastend7days)
        this.startDate = last7dasy;
        this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
      }
        break;
      case 4: {
        this.isDataLoaded = false;
        var lastMonthStartDay = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
        var lastMonthEndDay = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
        this.getDashbaordData(lastMonthStartDay, lastMonthEndDay)
        this.startDate = lastMonthStartDay;
        this.endDate = lastMonthEndDay;
      }
        break;

      default: console.log('Not Valid')
    }
  }

  setProductData(data) {
    var labels: string[] = [];
    var values: number[] = [];
    data.forEach(element => {
      labels.push(element.item_name);
      values.push(element.total);
    });
    this.pieChartLabels = labels;
    this.pieChartData = values;
  }

  setBarChartData(data) {

    data.forEach(element => {

      if (this.integrationsList[element.delivery_platform_id] != null) {
        element.backgroundColor = this.integrationsList[element.delivery_platform_id];
      }
    });

    return data;
  }

  getIntegrations() {
    this.deliveryService.getIntegrations(this.selectedFilterFranchise, this.selectedFilterShop).subscribe(res => {

      res.data.forEach(e => {
        this.integrationsList[e.id] = e.primary_color;
      })

    })
  }



  getDashbaordData(from_date, to_date) {

    let obj = {
      to_date: to_date,
      from_date: from_date,
      tenant_code: environment.x_tenant_code,
      outlet_code: this.outletCodes,
    }

    if (this.selectedActiveBrand) {
      obj['brand_id'] = this.selectedActiveBrand
    }

    this.reportService.getDashboardData(obj)
      .subscribe({
        next: (res) => {
          this.totalCount = res.data.total_orders;
          this.acceptedCount = res.data.accepted_orders;
          this.completedCount = res.data.completed_orders;
          this.readyCount = res.data.ready_for_pickup_orders;
          this.declinedCount = res.data.declined_orders;
          this.canceledCount = res.data.cancelled_orders;
          var barChatLabels = res.data.bar_chart.labels
          var barChartData = this.setBarChartData(res.data.bar_chart.stats)

          this.barChartLabels = barChatLabels;
          this.barChartData = barChartData;
          this.revenueBarChartLabels = barChatLabels;
          this.revenueBarChartData = res.data.revenue_stat;
          this.bestSellingPlatform = res.data.best_platform.url;
          this.bestSellingProducts = res.data.best_selling_product_list;
          this.totalrevenue = res.data.revenue;
          this.setProductData(res.data.all_products);

          this.totalReservations = res.data.confirmed_table_reservation_count;
          this.totalReservationsRevenue = res.data.table_reservation_revenue;
          this.bestZone = res.data.best_zone;
          this.totalNetRevenue = res.data.total_net_income;

          this.isDataLoaded = true;
        },
        error: (error) => { }
      });


  }

  updateMyDate(newDate) {

    if (newDate) {
      this.isDataLoaded = false;
      this.selectorActive = 5;

      var formatFromDate = moment(newDate[0]).format('YYYY-MM-DD');
      var formatToDate = moment(newDate[1]).format('YYYY-MM-DD');

      this.getDashbaordData(formatFromDate, formatToDate);
    }

  }

  onclickTab(tabId) {
    this.tabActive = tabId;
  }

  onclickRevenue() {

    let data = {
      franchise: this.selectedFilterFranchise,
      shop: this.selectedFilterShop,
      shop_code: this.selectedOutletCode
    }

    this.router.navigate([`/home/sales-report`, data]);

  }

  getRestaurantStatus() {
    if (localStorage.getItem('restaurantStatus')) {
      return (localStorage.getItem('restaurantStatus') == 'ONLINE' ? true : false);
    } else {
      return true;
    }
  }

  getCurrentUser() {
    this.loggedUserRole = this.authService.getLoggedUser().user_roles.role_id;
    this.userService.getCurrentUser().subscribe((res) => {
      this.authService.storeUser(res.data);
      this.authService.setReportToken(res.data.report_service_token);
      this.loggedUserRole = this.authService.getLoggedUser().user_roles.role_id;

      if (this.loggedUserRole > 2) {
        $("#spicker_shop").removeAttr("disabled");
      }

      if (this.selectedFilterFranchise && this.selectedFilterShop) {
        this.outletCodes.push(this.selectedOutletCode);
        this.getDashbaordData(this.startDate, this.endDate);
      } else {
        this.outletCodes = this.authService.getLoggedUser().user_outlets;
        this.getDashbaordData(this.startDate, this.endDate);
      }

    })
  }

  loadFilters() {

    if (!this.isFilterClicked) {
      this.isFilterClicked = true;
    } else {
      this.isFilterClicked = false;
    }
    $('#spicker_franchise').selectpicker('refresh');
    $('#spicker_franchise').selectpicker('val');
    $('#spicker_brand').selectpicker('refresh');
    $('#spicker_brand').selectpicker('val');
    $('#spicker_shop').selectpicker('refresh');

  }

  getAllFranchises() {
    this.adminService.getFranchises().subscribe((res) => {
      this.franchises = res.data;
    })
    $('#spicker_franchise').selectpicker('refresh');
    $('#spicker_franchise').selectpicker('val');
  }

  getTenants() {
    if (this.authService.getLoggedUser() != null) {

      this.adminService.getOutlets().subscribe((res) => {
        this.shops = res.data;
      })

    }
  }

  async getActiveBrands() {
    await this.deliveryService.getShopsRelatedBrands().subscribe(res => {
      console.log(res, "activeBrands");
      this.activeBrands = res.data

    })
    $('#spicker_brand').selectpicker('refresh');
    $('#spicker_brand').selectpicker('val');
  }

  async selectBrand(e) {

    this.selectedActiveBrand = e;
    this.getDashbaordData(this.startDate, this.endDate);

  }

  async selectFranchise(e) {

    this.selectedFilterFranchise = e;
    await this.adminService.getShopsRelatedFranchise(e)
      .subscribe({
        next: (res) => {
          this.shops = res.data
        },
        error: (error) => console.log(error)
      })
    setTimeout(function () {
      $("#spicker_shop").removeAttr("disabled");
      $('#spicker_shop').selectpicker('refresh');
      $('#spicker_shop').selectpicker('val', '')

    }, 1000);
  }

  selectShop(e) {
    if (e != null) {
      this.selectedOutletCode = e.code;
      this.selectedFilterShop = e.id;
      this.outletCodes = [];
      this.outletCodes.push(this.selectedOutletCode);
      this.getDashbaordData(this.startDate, this.endDate);
      this.isDataLoaded = false;
    }

  }

}
